(function () {
  const LOG = ">>> [StayAI PDP]";
  const ROOT = "purchase-options";

  // Sync discount percentage from the label to the first detail
  function syncFirstDetailFromLabel(source) {
    const selected = document.querySelector(`${ROOT} label.stayai-purchase-label.is-selected`);
    if (!selected) return;

    const labelSpan = selected.querySelector(
      ".stayai-purchase-label__inner__wrapper .subscription-label span",
    );
    const firstDetail = selected.querySelector(
      ".stayai-subscription-details-container ul li:first-child",
    );

    if (!labelSpan || !firstDetail) return;

    const text = labelSpan.textContent.trim();
    if (!text) return;

    firstDetail.textContent = text + ` off first order`;
  }

  function scheduleSync(source) {
    setTimeout(() => syncFirstDetailFromLabel(source), 0);
  }

  function init() {
    scheduleSync("init");

    window.addEventListener("variantChangeEnd", () => scheduleSync("variantChangeEnd"));

    window.addEventListener("stay-ai-subscription-changed", () =>
      scheduleSync("stay-ai-subscription-changed"),
    );
  }

  if (customElements.get("purchase-options")) init();
  else customElements.whenDefined("purchase-options").then(init);
})();
